import { Flex } from 'components/Flex';
import { useTranslation } from 'hooks/useTranslation';
import {
  CenteredCell,
  UnderlineButton,
} from 'pages/Settings/pages/Organization/SkillsPage/SkillsPage.styled';
import { FC } from 'react';

export const LocationAllocationCell: FC<{ count: number; onClick?: () => void }> = ({
  count,
  onClick,
}) => {
  const { t } = useTranslation();
  if (!count) return <CenteredCell>-</CenteredCell>;

  const label = t('location_settings:LOCATIONS_COUNT', { count });
  if (!onClick) return <CenteredCell>{label}</CenteredCell>;

  return (
    <Flex justifyContent="center">
      <UnderlineButton variant="PurpleText" width="auto" onClick={onClick}>
        {label}
      </UnderlineButton>
    </Flex>
  );
};
